/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({
    page,
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    conversationDirection,
    comunicanteCampaign,
  } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        conversation_direction: conversationDirection,
        comunicante_campaign: comunicanteCampaign,
      },
    });
  }

  downloadXlsx({
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    conversationDirection,
    comunicanteCampaign,
  } = {}) {
    const params = {
      since: from,
      until: to,
      sort: '-created_at',
      user_ids,
      inbox_id,
      team_id,
      rating,
      conversation_direction: conversationDirection,
      comunicante_campaign: comunicanteCampaign,
    };
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) delete params[key];
    });

    return axios.get(`${this.url}/download.xlsx`, {
      params,
      responseType: 'arraybuffer',
    });
  }

  getMetrics({
    from,
    to,
    user_ids,
    inbox_id,
    team_id,
    rating,
    conversationDirection,
    comunicanteCampaign,
  } = {}) {
    // no ratings for metrics
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        user_ids,
        inbox_id,
        team_id,
        rating,
        conversation_direction: conversationDirection,
        comunicante_campaign: comunicanteCampaign,
      },
    });
  }
}

export default new CSATReportsAPI();
